import { collection, getDocs, deleteDoc, setDoc, doc, updateDoc, query, where, onSnapshot, or, and } from "firebase/firestore";
import { db } from '../firebase-config';
import React, {useState, createContext, useEffect} from 'react';
import axios from 'axios';
import { getUserInfo } from "../components/Login";
import { defaultProspectModel, defaultTeamModel} from "./Models";
import dayjs from 'dayjs';
// trigger deployment

export const AppCTX = createContext();

export default function AppContext({children}) {
  const [user, setUser] = useState({
    uid: null,
    data: null,
  });
  const [prospects, setProspects] = useState([])
  const [openAddProspect, setOpenAddProspect] = React.useState(false);
  const [getPropertyDetails, setGetPropertyDetails] = useState(false)
  const [appointments, setAppointments] = useState([])
  const [leadType, setLeadType] = useState(0)
  const [status, setStatus] = useState('neutral')
  const [map, setMap] = useState(null);
  const [newProspect, setNewProspect] = useState(defaultProspectModel)
  const [teamData, setTeamData] = useState(defaultTeamModel)
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  useEffect(()=>{
    console.log('map loaded',isMapLoaded )
  },[isMapLoaded])

  //  When user joins this app for the first time
  useEffect(()=>{
    // below logic is to handle auto login via extracting the uid from local storage
    if (typeof localStorage !== 'undefined' && user.uid==null) {
      const uid = localStorage.getItem('firebase-uid');
      if(uid !== null){
        getUserInfo({uid:uid}).then((info)=>{
          setUser(info)
        })
      }
    } else {
      console.log('Local storage is not supported or UID does not exist in local storage');
    }
    // if user is authenticated
    if(user.uid!==null && user.data!=null){
      console.log('USER FOUND', user)
      getProspects()
      getTeamData()
      getAppointments()
    }
  },[user])

  useEffect(() =>{
    if(leadType > 0){
      setNewProspect(defaultProspectModel)
    }
  },[leadType])

  async function getPreciselyToken(apiKey, secret) {
    try {
      // Encode the API key and secret using base64
      const base64Value = btoa(`${apiKey}:${secret}`);

      // Define the token endpoint URL
      const tokenUrl = 'https://api.precisely.com/oauth/token';

      // Prepare the request headers
      const headers = {
        'Authorization': `Basic ${base64Value}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      };

      // Prepare the request body
      const requestBody = new URLSearchParams({
        'grant_type': 'client_credentials',
      });

      // Make the POST request to obtain the token
      const response = await fetch(tokenUrl, {
        method: 'POST',
        headers: headers,
        body: requestBody.toString(),
      });

      if (!response.ok) {
        throw new Error(`Failed to obtain token: ${response.statusText}`);
      }

      // Parse the response JSON to extract the access token
      const data = await response.json();
      const accessToken = data.access_token;

      return accessToken;
    } catch (error) {
      console.error('Error obtaining token:', error);
      throw error;
    }
  }

  const getProspects = async () => {
    try {

      // Get all prospects
      const q = query(collection(db, "prospects"), where("setter", "==", user.data.name));
      const querySnapshot = onSnapshot(q, (snapshot) => {
        console.log('Pulling prospects from db :', snapshot)
        let update = [...prospects];
        snapshot.forEach((doc) => {
          update.push(doc.data())
        })

        // seperate prospects to a new array
        const appointments = [];
        for (let i = update.length - 1; i >= 0; i--) {
          if (update[i].appointmentStart !== null) {
            appointments.push(update[i]);
            update.splice(i, 1); // Remove the object from the original array
          }
        }

        console.log('appointments found:', appointments)
        setAppointments(appointments)

        console.log('Prospects pulled in from firebase', update)
        setProspects(update)

      });
    } catch (error) {
      console.log(error)
      setStatus({notificationType:'error', message: 'error loading'});
      return [];
    }
  }

  const getAppointments = async () => {
    try {
      let q = query(collection(db, "prospects"),and( or(where("closer", "==", user.data.name), where("setter", "==", user.data.name)), where("appointmentSet", "==", true)));
      const querySnapshot = onSnapshot(q, (snapshot) => {
        console.log('Pulling appointments from db :', snapshot)
        let update = [];
        snapshot.forEach((doc) => {
          update.push(doc.data())
        })

        console.log('appointments found:', update)
        setAppointments(update)
      });
    } catch (error) {
      console.log(error)
      setStatus({notificationType:'error', message: 'error loading'});
      return [];
    }
  }


  const addProspect = async (newProspect) => {
    try{
        console.log('creating payload', newProspect);
        await setDoc(doc(db, "prospects", newProspect.address), newProspect)
        setStatus({notificationType:'success', message: 'prospect added successfully'})

      }catch(err){
        console.error(err)
        setStatus({notificationType:'error', message: 'something went wrong'})
      }
  }

  const updateProspect = async (updateProspect) => {
    try{
        console.log('creating payload', updateProspect);
        await setDoc(doc(db, "prospects", updateProspect.address), updateProspect)
        setStatus({notificationType:'success', message: 'client updated successfully'})
      }catch(err){
        console.error(err)
        setStatus({notificationType:'error', message: 'something went wrong'})
      }
  }

  const scheduleAppointment = async (prospect, day, time, selectedCloser, setNewAppointment ) =>{
    let dateTime = dayjs(day).format('YYYY-MM-DD')+"T"+dayjs(time).format('HH:mm')
    const prospectRef = doc(db, 'prospects', prospect.address);
    try {
      // Update the prospect document
      await updateDoc(prospectRef, {
        appointmentStart: dateTime,
        closer: selectedCloser,
        appointmentSet: true,
      });

      setStatus({notificationType:'success', message: 'appointment added'})
    } catch (error) {
      console.error('Error updating prospect:', error);
    }
  }

  const deleteProspect = async (address) => {
    try{
      const prospectRef = collection(db, "prospects");
      // Create a query against the collection.
      const q = query(prospectRef, where("address", "==", address));
      const querySnapshot = await getDocs(q);
      let docId = null;
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        docId = doc.id
      });

      await deleteDoc(doc(db, "prospects", docId));

    }catch(err){
      console.error(err)
      setStatus({notificationType:'error', message: 'something went wrong'})
    }
  }

  const sendSmsReminders = async (hopBackTime) => {
    const url = `http://localhost:5001/door-hopper/us-central1/helloWorld`;
    console.log('sending message')
    try{
      await axios.post(url, {address: newProspect.address, time: hopBackTime});
      setStatus({notificationType:'success', message: 'SMS notifcations setup successfully'})
    }catch(err){
      setStatus({notificationType:'error', message: 'Something went wrong'})
    }
  }

  const getTeamData = async () => {
    // this function should only run once
    const docRef = doc(db, "teams", user.data.teamName)
    try{
        const querySnapshot = onSnapshot(docRef, (snapshot) => {
        const team = snapshot.data()
        console.log('retrieved team data',team)
        setTeamData(team)
      })
    }catch(err){
      console.log(err)
    }
  }

  const updateTeamData = async () => {
    console.log('saving team data', teamData)
    try{
        await setDoc(doc(db, "teams", user.data.teamName), teamData)
        setStatus({notificationType:'success', message: 'new area assigned successfully'})
    }catch(err){
        console.log(err)
    }
  }

  const addAddress = async () => {
    try {
      if (!newProspect?.coords?.lat || ! process.env.REACT_APP_GOOGLE_MAPS_API_KEY) {
        setStatus({ notificationType: 'error', message: 'Missing coordinates or API key' });
        return;
      }
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${newProspect.coords.lat},${newProspect.coords.lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
      const { data } = await axios.get(url);
      console.log('response data ;',data)
      if (!data?.results?.[0]?.formatted_address) {
        setStatus({ notificationType: 'error', message: 'API ERROR' });
        return;
      }else{
        const temp = {...newProspect, address:data?.results?.[0]?.formatted_address}
        console.log('address added', temp)
        setNewProspect(temp)
      }
    } catch (error) {
      console.error('Address error:', error);
      setStatus({ 
        notificationType: 'error', 
        message: error.response?.data?.error_message || 'API ERROR'
      });
    }
  };

  return (
    <AppCTX.Provider value={{
        isMapLoaded,
        setIsMapLoaded,
        setMap,
        map,
        status,
        setStatus,
        sendSmsReminders,

        prospects,
        setProspects,
        getProspects,
        newProspect,
        setNewProspect,
        addProspect,
        updateProspect,
        deleteProspect,

        leadType,
        setLeadType,

        appointments,
        setAppointments,
        scheduleAppointment,

        user,
        setUser,

        teamData,
        setTeamData,
        updateTeamData,

        openAddProspect,
        setOpenAddProspect,
        addAddress,

        getPropertyDetails,
        setGetPropertyDetails
      }}>
      {children}
    </AppCTX.Provider>
  )
}
